import { render, staticRenderFns } from "./DemoIndicator.vue?vue&type=template&id=75779c4e&scoped=true&"
var script = {}
import style0 from "./DemoIndicator.vue?vue&type=style&index=0&id=75779c4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75779c4e",
  null
  
)

export default component.exports